import { render } from "./espa.html?vue&type=template&id=799e0ef4&scoped=true&lang=html&external"
import script from "./espa.component.vue?vue&type=script&lang=js"
export * from "./espa.component.vue?vue&type=script&lang=js"

import "./_espa.mobile.scss?vue&type=style&index=0&id=799e0ef4&lang=scss&scoped=true&external"
import "./_espa.desktop.scss?vue&type=style&index=1&id=799e0ef4&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799e0ef4"]])

export default __exports__